var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNavNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 18a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-16a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.707 4.707A.999.999 0 1 1 .293 3.293l3-3a.999.999 0 1 1 1.414 1.414l-3 3zM11 10.587l2.707 2.706a.999.999 0 1 1-1.414 1.414l-3-3A1.01 1.01 0 0 1 9 11V7a1 1 0 0 1 2 0v3.586zm8.707-7.294a.999.999 0 1 1-1.414 1.414l-3-3A.999.999 0 1 1 16.707.293l3 3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavNotification);
export default __webpack_public_path__ + "static/media/icon-nav-notification.9755cc8297c7972eac8677163a63f5d5.svg";
export { ForwardRef as ReactComponent };